<script lang="ts">
	import { trackDropPageViewAfterOpen } from '../../utils/trackDropPageViewAfterOpen/trackDropPageViewAfterOpen';
	import { getTimeContext } from '#lib/features/time/utils/getTimeContext/getTimeContext.js';
	import { getDirectusDateTimestamp } from '$global/utils/getDirectusDateTimestamp';

	interface Props {
		// Platform-namespaced event name, owned by the calling drop page. Optional
		// on CheckoutMixpanelEvents because only Editions and Primary define one,
		// so nothing is tracked when a site has not declared it.
		event: string | undefined;
		dropConfigId: string | null | undefined;
		slug: string;
		// Directus `drop_start_date` for this drop config.
		dropStartDate?: string | null;
		// True while the drop is open for purchase/application. Owned by the drop
		// page, which derives it from the live-drop-info response.
		isLive: boolean;
	}

	let { event, dropConfigId, slug, dropStartDate, isLive }: Props = $props();

	const { updatedTime } = getTimeContext();

	// Keyed on the drop rather than a plain boolean: SvelteKit reuses this
	// instance when navigating between two drop pages, so a bare flag would
	// suppress the second drop's event.
	let trackedFor = $state<string | null>(null);

	$effect(() => {
		// A drop is only ever accessible once it is already open — it goes live and
		// closes later — so this fires on arrival at an open drop, not at a
		// transition. `isLive` is still checked so nothing is tracked for a drop
		// whose checkout has already closed.
		if (!isLive || !dropConfigId || !event) {
			return;
		}

		// Once per drop per visit — the flag can settle more than once as the
		// page's derived state recomputes, and this event is a per-visit fact.
		if (trackedFor === dropConfigId || !$updatedTime) {
			return;
		}

		trackedFor = dropConfigId;

		trackDropPageViewAfterOpen({
			event,
			dropConfigId,
			slug,
			startedAt: dropStartDate
				? getDirectusDateTimestamp(dropStartDate)
				: undefined,
			now: $updatedTime,
		});
	});
</script>
